<template>
  <div class="change-lang">
    <router-link
      :to="routeChanged"
      v-html="$store.state.lang === 'it' ? 'en' : 'it'"
    />
  </div>
</template>

<script>
export default {
  name: 'changeLang',

  computed: {
    routeChanged() {
      const nextLang = this.$store.state.lang === 'en' ? 'it' : 'en';

      return `/${nextLang}`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~sass-mq/mq";
@import '../style/colors';
@import '../style/variables';
@import '../style/functions';

.change-lang {
  display: inline-block;
  position: relative;
  margin-left: 10px;

  a {
    display: block;
    position: relative;
    padding: 5px 20px;

    color: $color-text;
    pointer-events: all;
    cursor: pointer;


    @include mq(dm) {
      font-size: font-size(s);
    }
  }

  &::before {
    content: '';
    position: absolute;
    top: 46%;
    left: 50%;
    width: 30px;
    height: 30px;

    border-radius: 50%;
    border: 1px solid $color-text;

    transform: translateX(-50%) translateY(-50%);

    @include mq(dm) {
      width: 45px;
      height: 45px;
    }
  }
}
</style>
